import { useQuery } from '@tanstack/react-query';
import type {
  TuitionFeeBenchmarkFilterParams,
  TuitionFeeBenchmarkResult,
} from '@/features/reports/data/tuitionFeeBenchmark.types';
import {
  filterParamsToTuitionFeeBenchmarkApiParams,
  tuitionFeeBenchmarkApi,
} from '@/features/reports/api/tuitionFeeBenchmark.api';

export const tuitionFeeBenchmarkQueryKeys = {
  all: ['tuition-fee-benchmark'] as const,
  search: (params: TuitionFeeBenchmarkFilterParams) =>
    [...tuitionFeeBenchmarkQueryKeys.all, 'search', params] as const,
};

const PLACEHOLDER_PARAMS: TuitionFeeBenchmarkFilterParams = {
  year: '',
  gradeProgramId: '',
  gradeProgramTitle: '',
};

/**
 * Loads Tuition Fee Benchmark from GET /api/app/tuition-fee-benchmark/tuition-fee-benchmark.
 */
export function useTuitionFeeBenchmarkQuery(
  params: TuitionFeeBenchmarkFilterParams | null,
  enabled: boolean
) {
  const queryEnabled =
    enabled &&
    params != null &&
    Boolean(params.year?.trim()) &&
    Boolean(params.gradeProgramId?.trim());

  return useQuery<TuitionFeeBenchmarkResult>({
    queryKey: tuitionFeeBenchmarkQueryKeys.search(params ?? PLACEHOLDER_PARAMS),
    queryFn: async () => {
      const apiParams = filterParamsToTuitionFeeBenchmarkApiParams(params!);
      if (!apiParams) {
        throw new Error('Invalid search parameters.');
      }
      return tuitionFeeBenchmarkApi.getTuitionFeeBenchmark(apiParams);
    },
    enabled: queryEnabled,
    staleTime: 0,
  });
}
